import React from "react";
import { isMobileDevice } from "../../../utils";
import { Fa } from "../Icons/Fa";
import { Membership } from "../Icons/MembershipIcon";
import { Text } from "../Text/Text";
import { StyledButton } from "./Styles/StyledButton";
import { StyledButtonWrapper } from "./Styles/StyledButtonWrapper";
import { StyledCloseButton } from "./Styles/StyledCloseButton";
import { StyledContent } from "./Styles/StyledContent";
import { StyledFooter } from "./Styles/StyledFooter";
import { StyledHeader } from "./Styles/StyledHeader";
import { StyledMemberFooterBar } from "./Styles/StyledMemberFooterBar";
import { StyledModal } from "./Styles/StyledModal";
import { StyledModalContainer } from "./Styles/StyledModalContainer";
import { StyledTitle } from "./Styles/StyledTitle";

interface ModalProps {
  hasCloseIcon?: boolean;
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  onConfirm: React.MouseEventHandler<HTMLButtonElement>;
  headerTitle?: string;
  content?: string | JSX.Element;
  contentLineTwo?: string;
  hasCancelButton?: boolean;
  confirmButtonText: string;
  cancelButtonText?: string;
  isSectionModal?: boolean;
  modalTheme?: string;
  header?: string;
  footerText?: string;
  footerClick?: any;
  size?: string;
  memberOnlyGrayBar?: boolean;
  hasHeaderImage?: boolean;
  headerImageSrc?: string;
  confirmButtonSize?: string;
  isContentBold?: boolean;
  hasBorder?: boolean;
  roundedCorners?: boolean;
}

interface State {}

class Modal extends React.Component<ModalProps, State> {
  static defaultProps = {
    hasCloseIcon: true,
    hasCancelButton: false,
    cancelButtonText: "Cancel",
    isSectionModal: false,
    modalTheme: "primary",
    size: "md",
    memberOnlyGrayBar: false,
    confirmButtonSize: "md",
    isContentBold: false,
    hasBorder: false,
    roundedCorners:  true,
  };

  // state = { :  }

  render() {
    const {
      hasCloseIcon,
      onClose,
      onConfirm,
      headerTitle,
      hasHeaderImage,
      headerImageSrc,
      content,
      isContentBold,
      contentLineTwo,
      hasCancelButton,
      confirmButtonText,
      cancelButtonText,
      isSectionModal,
      modalTheme,
      header,
      footerText,
      footerClick,
      size,
      memberOnlyGrayBar,
      confirmButtonSize,
      hasBorder,
      roundedCorners,
    } = this.props;

    return (
      <StyledModal isSectionModal={isSectionModal} isMobile={isMobileDevice()}>
        <StyledModalContainer
          isMobile={isMobileDevice()}
          size={size}
          isSectionModal={isSectionModal}
          modalTheme={modalTheme}
          memberOnlyGrayBar={memberOnlyGrayBar}
          hasBorder={hasBorder}
          borderColor={modalTheme}
          roundedCorners={roundedCorners}
        >
          {hasCloseIcon && (
            <StyledCloseButton
              modalTheme={modalTheme}
              onClick={onClose}
              size="xl"
            >
              <Fa icon="times" aria-hidden="true" />
            </StyledCloseButton>
          )}

          <StyledHeader modalTheme={modalTheme} isMobile={isMobileDevice()}>
            <Text bold size="h4" align="center">
              {header}
            </Text>
          </StyledHeader>

          {hasHeaderImage && (
            <div>
              <img src={headerImageSrc} alt="header_image" />
            </div>
          )}

          <div>
            <StyledTitle modalTheme={modalTheme}>
              <Text bold size="h3" align="center">
                {headerTitle}
              </Text>
            </StyledTitle>

            <StyledContent
              modalTheme={modalTheme}
              isContentBold={isContentBold}
              style={{ marginTop: "4px" }}
            >
              <Text size="lg">{content}</Text>
            </StyledContent>
            <StyledContent
              modalTheme={modalTheme}
              isContentBold={isContentBold}
            >
              <Text size="lg">{contentLineTwo}</Text>
            </StyledContent>
          </div>

          <div>
            <StyledButtonWrapper>
              <StyledButton
                onClick={onConfirm}
                modalTheme={modalTheme}
                confirmButtonSize={confirmButtonSize}
              >
                <Text bold size="md">
                  {confirmButtonText}
                </Text>
              </StyledButton>
              {hasCancelButton && (
                <StyledButton
                  onClick={onClose}
                  modalTheme={modalTheme}
                  confirmButtonSize={confirmButtonSize}
                >
                  <Text bold size="md">
                    {cancelButtonText}
                  </Text>
                </StyledButton>
              )}
            </StyledButtonWrapper>

            <StyledFooter modalTheme={modalTheme}>
              <Text size="lg" align="center">
                <a onClick={footerClick}>{footerText}</a>
              </Text>
            </StyledFooter>
          </div>

          {memberOnlyGrayBar && (
            <div>
              <StyledMemberFooterBar>
                <Membership size="coverLarge" />
              </StyledMemberFooterBar>
            </div>
          )}
        </StyledModalContainer>
      </StyledModal>
    );
  }
}

export default Modal;
